
import '../App.css';
import Header from '../components/Header';
import ExecutiveCommittee from "../components/ExecutiveCommittee"
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
     <ExecutiveCommittee/>
    <Footer/>
    </div>
  );
}

export default App;
